// TMS 2026-10-08: hover zoom rewritten. Dawn's version shared one global overlay and only removed it on the
// overlay's own mouseleave, so scrolling under a still cursor (or moving fast between images) left a zoomed
// layer stuck on the photo. Now: zoom only while the mouse is over the image, and clear on leave, scroll,
// wheel, resize, tab switch or click. Mouse devices only; touch keeps the tap to open lightbox.
(function () {
  // product-info.js calls this after each variant change (2026-10-15 fix: it was missing, which froze Add to cart)
  window.enableZoomOnHover = function () {};
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var ZOOM = 2;
  var active = null; // { box, overlay }

  function clear() {
    if (!active) return;
    active.overlay.remove();
    active = null;
  }

  function move(box, img, e) {
    if (!active || active.box !== box) return;
    var r = box.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width;
    var y = (e.clientY - r.top) / r.height;
    if (x < 0 || x > 1 || y < 0 || y > 1) return clear();
    active.overlay.style.backgroundSize = r.width * ZOOM + 'px auto';
    active.overlay.style.backgroundPosition = x * 100 + '% ' + y * 100 + '%';
  }

  function start(box, img, e) {
    clear();
    var overlay = document.createElement('div');
    overlay.className = 'image-magnify-full-size';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.cssText = 'position:absolute;inset:0;pointer-events:none;background-repeat:no-repeat;' +
      'background-color:var(--gradient-background, #fff);background-image:url("' + (img.currentSrc || img.src) + '")';
    box.appendChild(overlay);
    active = { box: box, overlay: overlay };
    move(box, img, e);
  }

  function bind(img) {
    var box = img.parentElement;
    if (!box || box.dataset.tmsZoom) return;
    box.dataset.tmsZoom = '1';
    box.addEventListener('mouseenter', function (e) { start(box, img, e); });
    box.addEventListener('mousemove', function (e) {
      if (!active || active.box !== box) start(box, img, e); else move(box, img, e);
    });
    box.addEventListener('mouseleave', clear);
    box.addEventListener('click', clear);
  }

  function init() { document.querySelectorAll('img.image-magnify-hover').forEach(bind); }

  window.addEventListener('scroll', clear, { passive: true });
  window.addEventListener('wheel', clear, { passive: true });
  window.addEventListener('resize', clear);
  window.addEventListener('blur', clear);
  document.addEventListener('visibilitychange', clear);
  document.addEventListener('scroll', clear, { passive: true, capture: true }); // gallery slider scrolls too

  window.enableZoomOnHover = init;
  init();
  // variant changes re-render the gallery
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
})();
